<template>
  <div class="box flexHC2"  :style="type == 1 ? 'position: absolute;' : 'position: fixed;'">
    <div class="modal">
      <div class="code-box flexVC2">
        <img :src="codeImg" class="code-img">
      </div>
      <div class="title fontE1" v-if="title">{{title}}</div>
      <div class="subtitle" :style="title ? 'margin-top: 0.2rem;' : 'margin-top: 0.34rem;'" v-if="subtitle">{{subtitle}}</div>
      <img src="../assets/images/icon_modal_close.png" class="close-btn" @click="closeModal">
    </div>
  </div>
</template>

<script>
  export default {
    name: "CodeModal",
    props: ['codeImg','title','subtitle', 'type'],
    methods: {
      closeModal() {
        this.$emit('closeModal', '1')
      },
    }
  }
</script>

<style scoped>
  .box {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9998;
  }

  .modal {
    padding: 0.66rem;
    background: #FFFFFF;
    border-radius: 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
  }

  .code-box{
    width: 3.2rem;
    height: 3.2rem;
    background: #F2F2F7;
  }

  .code-img{
    width: 2.86rem;
    height: 2.86rem;
  }

  .title{
    width: 3.2rem;
    font-size: 0.28rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.2rem;
    text-align: center;
  }

  .subtitle{
    width: 3.2rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    text-align: center;
    line-height: 0;
  }

  .close-btn{
    width: 0.62rem;
    height: 1rem;
    position: absolute;
    right: 0;
    top: -1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/CodeModal.vue